import { render, staticRenderFns } from "./Ministry.vue?vue&type=template&id=c83ec164&scoped=true&"
import script from "./Ministry.vue?vue&type=script&lang=js&"
export * from "./Ministry.vue?vue&type=script&lang=js&"
import style0 from "./Ministry.vue?vue&type=style&index=0&id=c83ec164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83ec164",
  null
  
)

export default component.exports